import React from 'react';
import clsx from 'clsx';

import {
    Typography
} from '@material-ui/core';

import { useTranslation } from "react-i18next";

import BugReportIcon from '@material-ui/icons/BugReport'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 150,
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
    },
    image: {
        display: 'inline-block',
        marginTop: 50,
        width: '200px',
        height: '200px'
    }
}));

export const ErrorView = (props) => {
    const classes = useStyles();

    const { t } = useTranslation();

    return (
        <div className={clsx(classes.root, props.className)}>
            <Typography align="center" variant="h2">
                {t("LabelGenericError")}
            </Typography>
            <br />
            <Typography align="center" variant="body1">
                {t("LabelGenericErrorMessage")}
            </Typography>
            <br />
            <BugReportIcon className={classes.image} />
        </div>
    );
}